mutation RemoveSentenceGroupFromBarMitzvah($sentenceGroup: ID!, $barMitzvah: String!) {
  removeSentenceGroupFromBarMitzvah(sentenceGroup: $sentenceGroup, barMitzvah: $barMitzvah) {
    ok
    errors
  }
}
